import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { config } from 'app/constants';

@Component({
  selector: 'app-reminder-item',
  templateUrl: './reminder-item.component.html',
  styleUrls: ['./reminder-item.component.scss'],
})
export class ReminderItemComponent implements OnInit {
  @Input() index;
  @Input() reminder;

  @Output() reminderUpdate = new EventEmitter();
  @Output() setDisabledReminders = new EventEmitter();

  keys = config.reminder.keys;
  frequencys = config.reminder.frequencys;
  reminderTime: any = {
    period: this.keys[0],
    frequency: this.frequencys[0],
  };

  constructor() {}

  ngOnInit() {
    const periodTitle = {
      h: 'Hour',
      d: 'Day',
      w: 'Week',
    };
    this.reminderTime = {
      period: {
        title: `${periodTitle[this.reminder.key]}${
          this.reminder.frequency > 1 ? 's' : ''
        }`,
        value: this.reminder.key,
      },
      frequency: {
        title: this.reminder.frequency,
        value: this.reminder.frequency,
      },
    };
  }

  /** delete reminder */
  deleteReminder() {
    this.reminderUpdate.emit(this.index);
  }

  /** handle selection of period and frequency */
  handleSelect(type, value) {
    this.reminderTime[type] = value;
    if (type === 'period') {
      this.reminder.key = value.value;
    }
    if (type === 'frequency') {
      this.reminder.frequency = value.value;
      if (this.reminderTime.period.title.includes('Day')) {
        if (value.value > 1) {
          this.reminderTime.period.title = 'Days';
        } else {
          this.reminderTime.period.title = 'Day';
        }
      }

      if (this.reminderTime.period.title.includes('Week')) {
        if (value.value > 1) {
          this.reminderTime.period.title = 'Weeks';
        } else {
          this.reminderTime.period.title = 'Week';
        }
      }

      if (this.reminderTime.period.title.includes('Hour')) {
        if (value.value > 1) {
          this.reminderTime.period.title = 'Hours';
        } else {
          this.reminderTime.period.title = 'Hour';
        }
      }
    }

    this.setDisabledReminders.emit();
  }
}
